import { Component } from '@angular/core';
import { getYearOptions, monthOptions } from '../utils/helpers';
import { PaymentSlipService } from './services/payment-slip.service';
import { PaymentSlipResponseDTO } from '../interfaces/payment-slips.interface';
import { CompanyService } from '../services/company.service';
import { IComboBase } from '../interfaces/base/base.interface';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-payment-slips',
  templateUrl: './payment-slips.component.html',
  styleUrls: ['./payment-slips.component.scss'],
})
export class PaymentSlipsComponent {
  dataSource: PaymentSlipResponseDTO[] = [];
  mostrar: boolean = false;
  mostrarModalDetalle: boolean = false;
  dataDetail: any = null;
  dataToUpdate: any = null;
  mostrarModalValidar: boolean = false;

  // MES 
  monthOptions: IComboBase[] = [{ key: '00', text: 'Todos' }, ...monthOptions];
  currentMonth: IComboBase | null = null;
  selectedMonth: IComboBase | null = null;

  // AÑO
  yearOptions: IComboBase[] = [];
  selectedYear: IComboBase | null = null;

  isLoading: boolean = true;

  // Término de búsqueda
  searchTerm = '';
  pageIndex = 0;
  pageSize = 10;
  totalElements = 0;

  userData: any = null;

  tabs: IComboBase[] = [];
  selectedTabKey: string | null = null;

  selectedDocument: SafeResourceUrl | null = null;

  constructor(
    private paymentSlipService: PaymentSlipService,
    private companyService: CompanyService,
    private sanitizer: DomSanitizer
  ) {
    this.currentMonth = this.getCurrentMonth();
    this.selectedMonth = this.currentMonth;

    this.yearOptions = getYearOptions();
    this.selectedYear = this.yearOptions.find((y) => y.key === new Date().getFullYear().toString()) || null;
  }

  displayedColumns = [
    { key: 'paymentDocumentNumber', header: 'Nº Documento' },
    { key: 'paymentSlipAmount', header: 'Importe' },
    { key: 'period', header: 'Fecha' },
    { key: 'employeeName', header: 'Empleado' },
    { key: 'employeeDocumentNumber', header: 'D.N.I.' },
    { key: 'stateLastPaymentSlipName', header: 'Status' },
  ];

  actionButtons = [
    {
      icon: 'pi pi-check-square',
      color: '#ED672A',
      tooltip: 'Validar',
      action: (row: any) => {
        this.dataToUpdate = {
          ...row,
          empresa: this.tabs.find((tab) => tab.key === this.selectedTabKey),
        };
        this.mostrarModalValidar = true;
      },
      visible: (row: any) => row.stateLastPaymentSlipId === 2 ? true : false,
    },
    {
      icon: 'pi pi-eye',
      color: '#ED672A',
      tooltip: 'Ver',
      action: (row: any) => {
        console.log('Ver:', row);
        this.dataDetail = {
          ...row,
          empresa: this.tabs.find((tab) => tab.key === this.selectedTabKey),
        };
        this.mostrarModalDetalle = true;
      },
      visible: (row: any) => true,
    },
  ];

  ngOnInit(): void {
    const userDataString = localStorage.getItem('access');
    if (userDataString) {
      this.userData = JSON.parse(userDataString);
    }

    this.companyService.comboCompany().subscribe({
      next: (data) => {
        this.filterData();
      },
      error: (err) => {
        console.error('Error al obtener la lista de empresas:', err);
        this.filterData();
      },
    });
  }

  onNewRegister(): void {
    this.mostrar = true;
    console.log('click en nuevo');
  }

  onDialogDetailClose() {
    this.mostrarModalDetalle = false;
    this.dataDetail = null;
  }

  onUpdateStateComplete(): void {
    this.resetPagination();
    this.filterData();
  }

  onMonthChange(selected: IComboBase): void {
    this.selectedMonth = selected;
    this.resetPagination();
    this.filterData(); // Aplicar filtro cuando cambia el mes
  }

  onYearChange(selected: IComboBase): void {
    this.selectedYear = selected;
    this.resetPagination();
    this.filterData();
  }

  private getCurrentMonth(): IComboBase | null {
    const currentMonthKey = new Date().toLocaleDateString('en-GB', {
      month: '2-digit',
    });
    return (
      this.monthOptions.find((option) => option.key === currentMonthKey) || null
    );
  }

  onSearch(query: string): void {
    this.searchTerm = query;
    this.resetPagination();
    this.filterData(); // Aplicar filtro cuando cambia la búsqueda
  }

  filterData(): void {
    this.isLoading = true;
    const filters = {
      year: this.selectedYear?.key || null,
      month: this.selectedMonth?.key === '00' ? null : this.selectedMonth?.key || null,      
      search: this.searchTerm.trim() ? this.searchTerm.trim() : null,
      employeeId: this.userData?.employeeId,
      page: this.pageIndex,
      size: this.pageSize,
    };

    this.paymentSlipService.getAllPaymentSlips(filters).subscribe({
      next: (response) => {
        this.dataSource = response.content;
        this.totalElements = response.page.totalElements;
        this.pageIndex = response.page.page;
        this.pageSize = response.page.size;
        console.log('Datos filtrados:', this.dataSource);
        this.isLoading = false;
      },
      error: (err: any) => {
        this.isLoading = false;
        console.error('Error al obtener los datos:', err);
      },
    });
  }

  onTabSelected(tabKey: string): void {
    this.selectedTabKey = tabKey;
    console.log('Tab seleccionado:', tabKey);
    this.selectedDocument = null;
    this.resetPagination();
    this.filterData();
    // Puedes agregar lógica adicional aquí, como actualizar los datos mostrados
  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.filterData();
  }

  private resetPagination(): void {
    this.pageIndex = 0;
  }

  onRowSelected(row: any): void {
    if (row && row.paymentSlipUrl) {
      // Agregar un parámetro único para forzar la recarga
      const uniqueUrl = `${
        row.paymentSlipUrl
      }?timestamp=${new Date().getTime()}`;
      this.selectedDocument =
        this.sanitizer.bypassSecurityTrustResourceUrl(uniqueUrl);
      console.log('Documento seleccionado:', this.selectedDocument);
    } else {
      this.selectedDocument = null;
    }
  }
}
